<template>
  <b-field :type="error ? 'is-danger' : ''"
           :message="error"
           class="attachments-upload">
    <div class="attachments-field">
      <b-upload :disabled="loading || hasAttachment" :accept="acceptedFileTypes" @input="changeAttachmentsField">
        <ghost-button-with-icon
          :title="attachmentText"
          :disabled="!loading && hasAttachment"
          :loading="loading"
          :custom-classes="btnClasses">
          <svg-icon name="plus" width="16" height="16"></svg-icon>
        </ghost-button-with-icon>
      </b-upload>

      <div class="attachments-controls form-label">
        <template v-if="hasAttachment">
          <span v-for="file in fileAttachments" :key="file.name">{{ file.name }}</span>
          <span v-if="!loading" @click="cancelAttachments()">
            <svg-icon name="delete"></svg-icon>
          </span>
        </template>
        <span v-else :class="emptyLabelClasses">{{ emptyLabel }}</span>
      </div>
    </div>

  </b-field>
</template>
<script>

import './../../distribution/icons/plus';
import './../../distribution/icons/delete';

import GhostButtonWithIcon from '../buttons/GhostButtonWithIcon';

export default {
  props: {
    changeAttachmentsField: Function,
    fileAttachments: Array,
    acceptedFileTypes: {type: String, default: '*'},
    loading: {type: Boolean, default: false},
    error: String,
    emptyLabel: String,
    emptyLabelClasses: {type: String, default: ''},
    btnAttachmentText: {type: String, default: ''}
  },
  computed: {
    attachmentText() {
      return this.btnAttachmentText || this.$gettext('Add attachment');
    },
    hasAttachment() {
      return Boolean(this.fileAttachments && this.fileAttachments.length);
    },
    btnClasses() {
      let defaultBtnClasses = 'button is-primary-ghost-small';
      if (this.loading) {
        return defaultBtnClasses + ' is-loading';
      }

      return defaultBtnClasses;
    }
  },
  methods: {
    cancelAttachments() {
      this.changeAttachmentsField([]);
    }
  },
  components: {GhostButtonWithIcon}
};
</script>

<style lang="scss" scoped>
/deep/ .upload input[type='file'] {
  display: none;
}
.attachments-field {
  display: flex;
}

.attachments-controls {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-left: 10px;
  span {
    max-width: 275px;
    word-break: break-all;
  }
  .svg-icon {
    margin-left: 10px;
    stroke: var(--gray);

    cursor: pointer;
  }
}

/deep/ .help {
  margin-top: 10px;
  border-radius: 3px;
}
</style>
